module.exports = __webpack_public_path__ + "img/r-icon-1.40469a23.png";